import { Tab } from './types.js';
import { toTab } from './utils.js';
import type { UsePrefState } from '#~/preferences/hooks.js';
import { usePrefState } from '#~/preferences/hooks.js';

/** @internal */
export const useBottomTabPref = (): UsePrefState<Tab> =>
  usePrefState('room.bottom.tab', Tab.Presets, {
    deserialize: toTab
  });
